import AlertComponent from '../../control-components/ui-components/Alert'
import PrivateMessageTooltip from './PrivateMessageTooltip'

export default (props) => <AlertComponent {...props} component={PrivateMessageTooltip} />
